import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer__cta">
        <div className="site-container site-footer__cta-inner">
          <div><p className="site-eyebrow site-eyebrow--light">Contact us</p><h2>Questions about our cemetery or services?</h2></div>
          <Link className="site-button site-button--light" to="/contactus">Contact our team <span aria-hidden="true">→</span></Link>
        </div>
      </div>
      <div className="site-container site-footer__grid">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo" aria-label="Garden of Peace home"><img src="/images/logo2.png" alt="" /><span>Garden of Peace</span></Link>
          <p>A dignified Islamic cemetery serving Muslim families across Northern California with compassion, respect, and care.</p>
        </div>
        <nav aria-label="Footer about links"><h3>About</h3><Link to="/aboutus">Our story</Link><Link to="/whythisproject">Why this project</Link><Link to="/boardofdirectors">Our team</Link><Link to="/gallery">Gallery</Link></nav>
        <nav aria-label="Footer support links"><h3>Support</h3><Link to="/services">Services</Link><Link to="/volunteering">Volunteer</Link><Link to="/donate">Donate</Link><Link to="/QNA">Frequently asked questions</Link></nav>
        <div className="site-footer__contact"><h3>Contact</h3><a href="tel:+16692146771">(669) 214-6771</a><a href="mailto:gardenofpeace.usa@gmail.com">gardenofpeace.usa@gmail.com</a><p>17205 S Jasper Sears Road<br />Santa Nella, CA 95322</p><Link className="site-footer__contact-link" to="/contactus">Open contact form →</Link></div>
      </div>
      <div className="site-footer__bottom"><div className="site-container"><span>© {year} Garden of Peace. All rights reserved.</span><span>Serving our community with dignity and compassion.</span></div></div>
    </footer>
  );
};

export default Footer;
